import  { useState } from "react";
import { useFetchData } from "../../hooks/useFetchData";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import moment from "moment";
import { customStyles } from "../../utils/data/essential";
import { auditColumns } from "../../utils/columns/auditColumns";
const Audits = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const [username, setUsername] = useState("");
  const startdate = moment(fromDate).format("YYYY-MM-DD");
  const enddate = moment(toDate).format("YYYY-MM-DD");
  // const [audits, setAudits] = useState([]);
  const url = username !=="" ? `audits?username=${username}&from=${startdate}&to=${enddate}`: `audits?from=${startdate}&to=${enddate}`;
  const {
    data: audits,
    isFetching,
    refetch,
  } = useFetchData(["fetch-audits", url], url, false);
  const handleSearch = async () => {
    setLoading(true);
    await refetch();
    setLoading(false);
  };
  return (
    <>
      <div className='d-flex flex-wrap justify-content-center mt-4'>
        <div className='d-flex'>
          <label className='mr-2 mt-2'>Username:</label>
          <input
            type='text'
            placeholder='Enter username'
            className='form-control mr-2 h-100 input-select'
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className='d-flex'>
          <label className='mr-2 mt-2'>From:</label>
          <DatePicker
            className='form-control mr-2 h-100 input-select'
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat='dd/MM/yyyy'
          />
        </div>
        <div className='d-flex'>
          <label className='mr-2 ml-2 mt-2'>To:</label>
          <DatePicker
            className='form-control mr-2 h-100 input-select'
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat='dd/MM/yyyy'
          />
        </div>
      </div>
      <div className='d-flex justify-content-center ml-5'>
        <Button
          className='custom-btn-color'
          style={{ marginLeft: "7%" }}
          onClick={handleSearch}
          disabled={loading || isFetching} // Optional: prevent spam clicks
        >
          {loading || isFetching ? "Loading..." : "Search"}
        </Button>
      </div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={auditColumns}
          data={audits}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
    </>
  );
};
export default Audits;
